import React from 'react';
import { useFormContext } from 'react-hook-form';
import CaseNumberField from './CaseNumberField';
import TextField from '../../../../../../../../Inputs/TextField';
import classNames from 'classnames';
import styles from '../../index.module.scss';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../../hooks/useIntakeBlockToggle';
import { patientFieldsValidation } from '../../../../../../../../../utils/validationUtil';
import useFeatureMap from '../../../../../../../../../hooks/useFeatureMap';

const EMRBlock = () => {
  const {
    register,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const { isOn, isRequired } = useIntakeBlockToggle();

  const { enableMrn, enableExternalEmr } = useFeatureMap();

  if (!isOn(intakeBlocksEnum.emr)) {
    return null;
  }

  return (
    <div className={styles.gap} data-cy={'administrative-block'}>
      {enableExternalEmr ? (
        <div className="flex flex-1">
          <TextField
            label="Patient ID"
            wrapperClassName={classNames(styles.inputWrapper, styles.emrBlock)}
            inputClassName={styles.inputField}
            {...register('emrNumber', {
              required: isRequired(intakeBlocksEnum.emr) ? 'Please Enter Patient ID' : '',
              ...patientFieldsValidation.patientId,
            })}
            error={!!errors?.emrNumber}
            required={isRequired(intakeBlocksEnum.emr)}
            helperText={errors?.emrNumber?.message}
            onInput={() => clearErrors('emrNumber')}
          />
        </div>
      ) : null}
      {enableMrn ? (
        <div className="flex flex-1">
          <TextField
            label="MRN"
            wrapperClassName={classNames(styles.inputWrapper, styles.emrBlock)}
            inputClassName={styles.inputField}
            {...register('mrn', {
              required: isRequired(intakeBlocksEnum.emr) ? 'Please Enter MRN' : '',
              ...patientFieldsValidation.mrn,
            })}
            error={!!errors?.mrn}
            required={isRequired(intakeBlocksEnum.emr)}
            helperText={errors?.mrn?.message}
            onInput={() => clearErrors('mrn')}
          />{' '}
        </div>
      ) : null}
      <CaseNumberField />
    </div>
  );
};
export default EMRBlock;
